import AntdButton from "components/AntdButton"
import AntdModal from "components/AntdModal"
import { EditOutlined, PlusOutlined } from "@ant-design/icons"
import React, { useEffect, useState } from "react"
import AddressForm from "./AddressForm"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { EmployeeAddress } from "@type/employees.types"
import { EmployeeAddressesSchema } from "Schema"
import useAppSelector from "hooks/useAppSelector"
import { isEmployeeAddressesSaving, saveEmployeeAddress } from "store/Employee/address.slice"
import useAppDispatch from "hooks/useAppDispatch"
import useSchedulesQueryParams from "hooks/useSchedulesQueryParams"

interface Props {
	resetFields?: EmployeeAddress
}

const AddressModal: React.FC<Props> = ({ resetFields = null }) => {
	const dispatch = useAppDispatch()
	const employeeAddressSaving = useAppSelector(isEmployeeAddressesSaving())
	const { selectedEmployee = "" } = useSchedulesQueryParams()
	const [isModalOpen, setIsModalOpen] = useState(false)

	const methods = useForm<EmployeeAddress>({
		resolver: yupResolver(EmployeeAddressesSchema),
	})

	const {
		handleSubmit,
		formState: { isDirty },
		reset,
	} = methods

	const onFormSubmit = (data: EmployeeAddress) => {
		dispatch(
			saveEmployeeAddress(
				{ ...data, employee: selectedEmployee, ...(!!resetFields?._id && { _id: resetFields._id }) },
				() => setIsModalOpen(false),
			),
		)
	}

	useEffect(() => {
		if (resetFields) reset({ ...resetFields })
	}, [resetFields])

	return (
		<div>
			{resetFields ? (
				<AntdButton
					className="flex w-min items-center justify-center"
					onClick={() => setIsModalOpen(true)}
					icon={<EditOutlined />}
				>
					Update
				</AntdButton>
			) : (
				<AntdButton
					className="flex w-min items-center justify-center"
					onClick={() => setIsModalOpen(true)}
					icon={<PlusOutlined />}
				>
					Add New
				</AntdButton>
			)}
			{isModalOpen && (
				<AntdModal
					open={isModalOpen}
					okText={resetFields ? "Update" : "Save"}
					onCancel={() => setIsModalOpen(false)}
					title={"Add new address"}
					onOk={handleSubmit(onFormSubmit)}
					okButtonProps={{ loading: employeeAddressSaving, disabled: !isDirty }}
				>
					<FormProvider {...methods}>
						<AddressForm />
					</FormProvider>
				</AntdModal>
			)}
		</div>
	)
}

export default AddressModal
